import IndividualTable from "../../../IndividualTable";
import { sampleData2 } from "../../sampleData";

const Distance70 = () => {
  let winners = ["219", "524"];

  return <IndividualTable matchType={"4"} gender="F" event="70" subTitle="Puta" data={sampleData2} topRankCount="2" winners={winners} />;
};
export default Distance70;
